class Preloader  {

    constructor(options) {

        this.settings = $.extend({
            container: null, // jquery
            loader: '<div class="preloader"><div class="preloaderInner"><div class="loader"></div></div></div>',
            onResize: false, // true o false
            onstartCallback: null, // jquery
            onstopCallback: null, // jquery
        },options);

        if(this.settings.container === null){
            return;
        }

        this.$loader = $(this.settings.loader);
        this.isActive = false;

        this.init();

    }

    init(){
        this.settings.container.append(this.$loader.hide());
    }

    start() {
        this.isActive = true;
        // call onstartCallback if exist
        if(this.settings.onstartCallback !== null){
            this.settings.onstartCallback(this.settings.container);
        }
        this.$loader.show();
    }

    stop() {
        this.isActive = false;
        // call onstopCallback if exist
        if(this.settings.onstopCallback !== null){
            this.settings.onstopCallback(this.settings.container);
        }
        this.$loader.hide();
    }

}

export default Preloader;



// WEBPACK FOOTER //
// ./scripts/classes/preloader.js